module.exports = __webpack_public_path__ + "media/images/ico-settings-923c66f9b76daaee747435a2f2c7de48.svg";